// extracted by mini-css-extract-plugin
export default {"cursor":"TypewriterText_cursor__U5b2A","cursorBlink":"TypewriterText_cursorBlink__YIBF4"};